import Api from '~/api'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'
import { resetForm, formSuccess, isLoading, formError } from '~/form/actions'

export function createArticle(formId, item, onCreate) {
  return (dispatch, getState) => {
    Api.post('/article', { item })
      .then(({ data = {} }) => {
        if (data.success) {
          if (onCreate) onCreate(data.item)

          dispatch(createArticleSuccess(data.item))
          dispatch(resetForm(formId))
        }

        if (data.message) dispatch(formError({ messages: [data.message] }))
      })
      .catch(err => dispatch(formError({ messages: [err.message || 'Error when creating task'] })))
  }
}

export function createArticleSuccess(item) {
  return {
    type: 'ARTICLE_CREATE_SUCCESS',
    table_id: 'articles',
    item,
  }
}

export function updateArticle(formId, articleId, item, onSubmit) {
  return (dispatch, getState) => {
    Api.patch(`/article/${articleId}`, { item })
      .then(({ data = {} }) => {
        if (data.success) {
          if (onSubmit) onSubmit(data.item)

          dispatch(updateArticleSuccess(data.item))
          dispatch(resetForm(formId))
        }

        if (data.message) dispatch(formError({ messages: [data.message] }))
      })
      .catch(err => dispatch(formError({ messages: [err.message || 'Error when creating task'] })))
  }
}

export function updateArticleSuccess(item) {
  return {
    type: 'ARTICLE_UPDATE_SUCCESS',
    table_id: 'articles',
    item,
  }
}
